$component-class: 'sn-reviews-decoration';

.#{$component-class}__container {
  position: relative;
  display: none;

  @include above($breakpoint-desktop-md) {
    display: block;
  }

  @include above(1280px) {
    height: 503px;
    width: 568px;
  }
}

.#{$component-class}__item {
  position: absolute;
  opacity: 0;
  transition:
    opacity var(--animation-duration, 1000ms) ease-out,
    transform var(--animation-duration, 1000ms) ease-out;
  transition-delay: var(--animation-delay, 0ms);

  // Default animation: fade-up
  &[data-animation-type='fade-up'] {
    transform: translateY(30px);

    &.is-visible {
      opacity: 1;
      transform: translateY(0);
    }
  }

  // Animation: fade-right
  &[data-animation-type='fade-right'] {
    transform: translateX(-30px);

    &.is-visible {
      opacity: 1;
      transform: translateX(0);
    }
  }

  // Animation: fade-left
  &[data-animation-type='fade-left'] {
    transform: translateX(30px);

    &.is-visible {
      opacity: 1;
      transform: translateX(0);
    }
  }

  // Item positioning - based on original CSS
  &[data-id='01'] {
    left: 0;

    @include above(960px) {
      height: 54px;
      top: 49px;
      width: 223px;
    }

    @include above(1280px) {
      height: 70px;
      top: 68px;
      width: 283px;
    }
  }

  &[data-id='02'] {
    @include above(960px) {
      height: 156px;
      left: 240px;
      top: -4px;
      width: 140px;
    }

    @include above(1280px) {
      height: 202px;
      left: 302px;
      top: 0;
      width: 182px;
    }
  }

  &[data-id='03'] {
    @include above(960px) {
      height: 38px;
      right: 20px;
      top: 55px;
      width: 38px;
    }

    @include above(1280px) {
      height: 48px;
      right: 16px;
      top: 76px;
      width: 48px;
    }
  }

  &[data-id='04'] {
    @include above(960px) {
      height: 38px;
      left: 30px;
      top: 171px;
      width: 38px;
    }

    @include above(1280px) {
      height: 48px;
      left: 33px;
      top: 226px;
      width: 48px;
    }
  }

  &[data-id='05'] {
    @include above(960px) {
      height: 156px;
      left: 84px;
      top: 111px;
      width: 140px;
    }

    @include above(1280px) {
      height: 202px;
      left: 100px;
      top: 149px;
      width: 182px;
    }
  }

  &[data-id='06'] {
    @include above(960px) {
      height: 53px;
      right: 0;
      top: 159px;
      width: 217px;
    }

    @include above(1280px) {
      height: 70px;
      right: -4px;
      top: 211px;
      width: 270px;
    }
  }

  &[data-id='07'] {
    @include above(960px) {
      height: 32px;
      left: 64px;
      top: 284px;
      width: 160px;
    }

    @include above(1280px) {
      height: 42px;
      left: 85px;
      top: 371px;
      width: 198px;
    }
  }

  &[data-id='08'] {
    @include above(960px) {
      height: 40px;
      left: 146px;
      top: 326px;
      width: 75px;
    }

    @include above(1280px) {
      height: 52px;
      left: 190px;
      top: 425px;
      width: 92px;
    }
  }

  &[data-id='09'] {
    @include above(960px) {
      height: 156px;
      left: 239px;
      top: 230px;
      width: 140px;
    }

    @include above(1280px) {
      height: 202px;
      left: 301px;
      top: 302px;
      width: 182px;
    }
  }

  &[data-id='10'] {
    @include above(960px) {
      height: 38px;
      right: 20px;
      top: 284px;
      width: 38px;
    }

    @include above(1280px) {
      height: 48px;
      right: 16px;
      top: 372px;
      width: 48px;
    }
  }

  // Ensure images fill their containers
  img,
  picture,
  me-picture {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  // Handle me-picture component wrapper
  me-picture {
    display: block;
    width: 100%;
    height: 100%;

    .picture {
      width: 100%;
      height: 100%;

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
  }
}
